import { Select, type SelectProps } from '@mantine/core';
import { STATUS_BADGE_SELECT_OPTIONS } from './constants';
import { IconChevronsUp, IconCircleFilled } from '@tabler/icons-react';
import { VACANCY_STATUS_MODEL } from '../constants';
import { VacancyStatusSelectOption } from './vacancyStatusSelectOption';

const getLeftSectionIconColor = (status: string) => {
  switch (status) {
    case VACANCY_STATUS_MODEL.NEW:
      return 'var(--mantine-color-primary-2)';
    case VACANCY_STATUS_MODEL.IN_PROGRESS:
      return 'var(--mantine-color-secondary-2)';
    case VACANCY_STATUS_MODEL.SELECTION_SUSPENDED:
      return 'var(--mantine-color-tertiary-2)';
    case VACANCY_STATUS_MODEL.SELECTION_COMPLETED:
      return 'var(--mantine-color-green-2)';
    case VACANCY_STATUS_MODEL.SELECTION_CANCELLED:
      return 'var(--mantine-color-red-0)';
    case VACANCY_STATUS_MODEL.ARCHIVED:
      return 'var(--mantine-color-red-0)';
    default:
      return '';
  }
};

type VacancyStatusSelect = {
  status?: string;
} & SelectProps;

export const VacancyStatusSelect = ({
  status,
  data = STATUS_BADGE_SELECT_OPTIONS,
  ...props
}: VacancyStatusSelect) => {
  if (!status) {
    return null;
  }

  return (
    <Select
      data={data}
      rightSection={<IconChevronsUp color='var(--mantine-color-primary-7)' />}
      leftSection={
        <IconCircleFilled color={getLeftSectionIconColor(status)} size={10} />
      }
      renderOption={item => (
        <VacancyStatusSelectOption status={item.option.value} />
      )}
      maxDropdownHeight={300}
      styles={{
        dropdown: {
          maxHeight: '320px',
          overflowY: 'auto',
        },
      }}
      {...props}
    />
  );
};
